import { EmailIsRequiredForMagicLinkError } from '~/errors/errors';
import { authGateway, LoginRequest, MagicLinkRequest } from '~/gateways/auth/authGateway';
import { GetCompanyInfoUseCase } from '../getCompanyInfoUseCase';
import { MagicUseCase } from '../magicUseCase';

export class SendMagicLinkUseCase extends MagicUseCase {
  protected async runLogic(request: LoginRequest) {
    this.getState().user.loginInfo.error = undefined;
    if (!this.getState().user.companyInfo?.id) {
      await new GetCompanyInfoUseCase().execute(request.domain);
    }
    const companyId = this.getState().user.companyInfo?.id;
    if (!request.email) {
      throw new EmailIsRequiredForMagicLinkError();
    }
    const loginInfo: MagicLinkRequest = {
      email: request.email,
      companyId,
    };
    await authGateway.sendMagicLink(loginInfo);
  }
}
